export enum FormFieldSource {
  /** Поле добавлено из каталога и не сохранено */
  FROM_CATALOG_NOT_SAVED = 'FROM_CATALOG_NOT_SAVED',
  /** Поле создано пользователем и не сохранено */
  CUSTOM_FIELD_NOT_SAVED = 'CUSTOM_FIELD_NOT_SAVED',
  /** Поле сохранено на сервере и синхронизировано */
  FIELD_SAVED = 'FIELD_SAVED',
}
